import { TBaseDataLayer } from '@typescript/index';
const GoogleTagManagerViewMiniCart = () => {
  const tagManagerArgs: TBaseDataLayer = {
    event: 'ga4Event',
    eventAction: 'show_mini_cart'
  };
  if (window && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: null
    });
    window.dataLayer.push(tagManagerArgs);
  }
};
export default GoogleTagManagerViewMiniCart;